import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
let ContentTile = class ContentTile extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "text", void 0);
    _defineProperty(this, "total", void 0);
    _defineProperty(this, "subTotal", void 0);
    _defineProperty(this, "icon", void 0);
  }
};
__decorate([Prop({
  required: true
})], ContentTile.prototype, "text", void 0);
__decorate([Prop({
  required: true
})], ContentTile.prototype, "total", void 0);
__decorate([Prop()], ContentTile.prototype, "subTotal", void 0);
__decorate([Prop({
  required: true
})], ContentTile.prototype, "icon", void 0);
ContentTile = __decorate([Component({
  components: {
    Icon
  }
})], ContentTile);
export default ContentTile;